import { CredentialItem } from './credential-item'

export class MembershipCredentialItem extends CredentialItem {

  public constructor(data: any) {
    super(data)

    const { eligibility_status: value, effective_at, expires_at, status } = this.credential
    switch (value) {
      case 'invalid': {
        if (status === 'Canceled') this.setStatusTag({ color: 'red', value: status })
        else this.setStatusTag({ color: 'yellow', value })
        break
      }
      case 'expired': {
        this.setStatusTag({ color: 'red', value })
        this.validityLabel = `Expired ${this.getDate(expires_at)}`
        break
      }
      case 'upcoming':
      case 'valid': {
        if (!expires_at) this.validityLabel = 'Lifetime Membership'
        else this.validityLabel = `Valid from ${this.getDate(effective_at)} - ${this.getDate(expires_at)}`
        this.setStatusTag({ value: 'paid' })
        break
      }
      default: this.defaultStatusTag()
    }
  }

}
